import { render, staticRenderFns } from "./DocumentsAdd.vue?vue&type=template&id=494782e5"
import script from "./DocumentsAdd.vue?vue&type=script&lang=js"
export * from "./DocumentsAdd.vue?vue&type=script&lang=js"
import style0 from "./DocumentsAdd.vue?vue&type=style&index=0&id=494782e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports